"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createElementsScrollPositions = createElementsScrollPositions;
function createElementsScrollPositions() {
    const scrollPositionsByElement = new WeakMap();
    return {
        set(element, scrollPositions) {
            if (element === document && !document.scrollingElement) {
                // cf https://drafts.csswg.org/cssom-view/#dom-document-scrollingelement,
                // in some cases scrolling elements can not be defined, we don't support those for now
                return;
            }
            scrollPositionsByElement.set(element === document ? document.scrollingElement : element, scrollPositions);
        },
        get(element) {
            return scrollPositionsByElement.get(element);
        },
        has(element) {
            return scrollPositionsByElement.has(element);
        },
    };
}
//# sourceMappingURL=elementsScrollPositions.js.map